import Cd4pe from './Cd4pe';

export default Cd4pe;
